/*
   this method takes a startTime which is expected to end in HH:MM:SS+00:00 format.
   this method cannot simply be replaced with timeZoneOffset, because it does not
   account for daylight savings time

   iCalendar RFC: https://www.ietf.org/rfc/rfc2445.txt
*/
const getTimeZoneOffset = timestamp => {
  const tzData = /[-+]{1}(\d{2}):(\d{2})$/.exec(timestamp);
  if (tzData) {
    return (
      (tzData[0].startsWith('+') ? 1 : -1) *
      (parseInt(tzData[1], 10) * 60 + parseInt(tzData[2], 10))
    );
  }
  const utcCheck = /Z$/.test(timestamp); // terminating Z indicates UTC
  if (utcCheck) {
    return 0;
  }
  return -1 * new Date(timestamp).getTimezoneOffset(); // no terminal indicator means local time
};

export default getTimeZoneOffset;
